import { render, staticRenderFns } from "./DatasetUpdater.vue?vue&type=template&id=84dc4ae8&scoped=true"
import script from "./DatasetUpdater.vue?vue&type=script&lang=js"
export * from "./DatasetUpdater.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84dc4ae8",
  null
  
)

export default component.exports